// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  max-height: 100vh;
  overflow: auto;
}

.container {
  width: 100%;
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
  background: transparent;
  height: 60px;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.button {
  width: 100%;
  padding: 10px;
  margin-top: 20px;
}
.button .close {
  background: var(--ion-color-primary);
  text-align: center;
  border-radius: 50px;
}
.button .close p {
  text-align: center;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;AACF;;AACA;EACE,WAAA;EACA,aAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AAGF;AADI;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAGN;AAFM;EACE,YAAA;AAIR;;AACA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAEF;AADE;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;AAFI;EACE,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;AAIN","sourcesContent":[":host {\n  max-height: 100vh;\n  overflow: auto;\n}\n.container {\n  width: 100%;\n  padding: 20px;\n}\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0px;\n  background: transparent;\n  height: 60px;\n  .icon_wrapper {\n    ion-icon {\n      height: 10px;\n      width: 10px;\n      rotate: 180deg;\n      transition: rotate 0.5s;\n      margin-left: 10px;\n      &.isOpen{\n        rotate: 0deg;\n      }\n    }\n  }\n}\n.button {\n  width: 100%;\n  padding: 10px;\n  margin-top: 20px;\n  .close {\n    background: var(--ion-color-primary);\n    text-align: center;\n    border-radius: 50px;\n    p {\n      text-align: center;\n      font-size: 18px;\n      font-family: AppFontBold, sans-serif;\n      color: white !important;\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
